"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaceForRewards = void 0;
const useDropMedia_1 = require("root/src/client/v2/drop/hooks/useDropMedia");
const useRecordId_1 = require("root/src/client/v2/common/hooks/useRecordId");
const RaceForRewardsPlayers_1 = require("root/src/client/v2/drop/features/RaceForRewards/RaceForRewardsPlayers");
const RaceForRewardsHeader_1 = require("root/src/client/v2/drop/features/RaceForRewards/RaceForRewardsHeader");
function RaceForRewards() {
    const recordId = (0, useRecordId_1.useRecordId)();
    if (!recordId) {
        return null;
    }
    const { data: media, isLoading, } = (0, useDropMedia_1.useDropMedia)(recordId);
    if (typeof media === 'undefined' || isLoading || media.length === 0) {
        return null;
    }
    return (<div className="bg-black p-10">
			<RaceForRewardsHeader_1.RaceForRewardsHeader />
			<RaceForRewardsPlayers_1.RaceForRewardsPlayers media={media}/>
		</div>);
}
exports.RaceForRewards = RaceForRewards;
